<script>
    import { alt }          from '../store.js';
    import { fade, fly }    from 'svelte/transition';

    export let height;
    export let image;

    export let imageMobile  = image;
    export let title        = 'Vitrine';
    export let link         = 'javascript:void()';
    export let target       = '';
    export let video        = '';
    export let videoWidth   = '450';
    export let videoHeight  = '250';
</script>

<style type="text/sass">
.image 
    background-repeat: no-repeat
    background-position: center
    background-size: cover
    .link
        width: 100%
        display: inline-block

.video
    width: 100%
    height: 100%
    display: flex
    align-items: center 
</style>

<div class="item">
    <!-- Vitrine Desktop -->
    <div class="image d-none d-xl-block" style="background-image: url('/images/vitrines/{image}'); height: {height}">
        <div class="container">
            <a class="link" href="{link}" title="{title}{$alt}" {target} style="height: {height}">
                <img src="/images/vitrines/{image}" alt="{title}{$alt}" style="display: none;"/>
                {#if video != ''}
                    <div class="video" in:fly="{{ x: 300, duration: 2000 }}">
                        <iframe width={videoWidth} height={videoHeight} src="https://www.youtube.com/embed/{video}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                {/if}
            </a>
        </div>
    </div>
    <!-- Vitrine Mobile -->
    <div class="image d-lg-none" style="background-image: url('/images/vitrines/{imageMobile}'); height: {height}">
        <div class="container">
            <a class="link" title="{title}{$alt}" href="{link}" target="{target}" style="height: {height}">
                <img src="/images/vitrines/{imageMobile}" alt="{title}{alt}" style="display:none"/>
            </a>
        </div>
    </div>
</div>